import { createAsyncThunk } from "@reduxjs/toolkit";

import api from "../../../utils/api";

// Busqueda de Locations
export const getSignatureProviders = createAsyncThunk(
  "signatureProviders/getSignatureProviders",
  async (arg, { rejectWithValue }) => {
    try {
      // Busca los proveedores de firma
      const token = localStorage.getItem("token");
      const headers = new Headers();
      headers.append("Authorization", `Bearer ${token}`);
      headers.append("Content-Type", "application/json");

      const response = await fetch(`${api.baseURL}signatureproviders?sort=code%20ASC`, {
        method: "GET",
        headers: headers,
      });
      const data = await response.json();
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
